import React, { useState, useEffect } from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useTheme, useMediaQuery } from '@mui/material';

const Step = ({ number, label, active, onClick, disabled }) => {
  return (
    <FlexContainer
      className={'flex-column align-items-center pointer'}
      style={{
        minWidth: 80,
      }}
      onClick={() => {
        if (!disabled && onClick) onClick();
      }}
    >
      <FlexContainer
        className={
          'width-26px height-26px align-items-center justify-center text-12 index-2'
        }
        style={{
          borderRadius: '50%',
          background: active ? '#6f8ec0' : '#ffffff',
          border: active ? '3px solid #6f8ec0' : '3px solid #6f8ec0',
          boxShadow: active ? '0 2px 6px rgba(87,180,62,0.25)' : 'none',
          color: active ? '#fff' : '#000001',
          fontWeight: 800,
        }}
      >
        {number}
      </FlexContainer>

      <Label
        className={'text-10 margt4 text-center width-180px'}
        style={{
          color: '#53595f',
          fontWeight: '700',
        }}
      >
        {label}
      </Label>
    </FlexContainer>
  );
};

const AgendaCitaFechaModal = ({
  open,
  onClose,
  goStep1,
  goStep2,
  goStep4,
  filteredDoctorList,
  listaEspecialidades,
  changueEspFilter,
  selectedSpeciality,
  changeDoctorFilter,
  selectedDoctor,
  medicalHistory,
  selectSchedule,
  currentStep,
  setCurrentStep,
  isLoadingSpeciality,
  isLoadingHistory,
  isLoadingDoctor,
  setIsLoadingDoctor,
}) => {
  const [indexInicio, setIndexInicio] = useState(0);
  const [seleccion, setSeleccion] = useState({ day: null, hour: null });
  const [diasDisponibles, setDiasDisponibles] = useState([]);
  //const [isLoadingDoctor, setIsLoadingDoctor] = useState(false);
  const [mobileIndex, setMobileIndex] = React.useState(0);
  const [dayNotAvailableMessage, setDayNotAvailableMessage] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getPeruNow = () => {
    return new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Lima' }),
    );
  };

  const isPastHour = (fecha, hora) => {
    const now = getPeruNow();

    const [hh, mm] = hora.split(':').map(Number);

    const dateToCompare = new Date(`${fecha}T${hora}:00`);

    return (
      dateToCompare.toDateString() === now.toDateString() &&
      (hh < now.getHours() || (hh === now.getHours() && mm <= now.getMinutes()))
    );
  };

  const handleCboEspeciality = value => {
    changueEspFilter(value, true);
  };

  useEffect(() => {
    if (!Array.isArray(medicalHistory)) return;

    const map = {};

    medicalHistory.forEach(item => {
      const fecha = item.fecha_de_atencion;
      const hora = item.hora_de_atencion?.slice(0, 5);
      if (!fecha || !hora) return;

      if (!map[fecha]) {
        const date = new Date(`${fecha}T00:00:00`);

        map[fecha] = {
          fecha,
          num: date.getDate().toString().padStart(2, '0'),
          mes: date.toLocaleString('es-ES', { month: 'short' }).toUpperCase(),
          dia: date.toLocaleString('es-ES', { weekday: 'short' }).toUpperCase(),
          horas: [],
        };
      }

      const indiceExistente = map[fecha].horas.findIndex(h => h.hora === hora);

      const datosDelTurno = {
        hora,
        libre: item.estado_de_horario === 'LIBRE',
        estado: item.estado_de_horario,
        codigo: item.codigo,
      };

      if (indiceExistente === -1) {
        map[fecha].horas.push(datosDelTurno);
      } else {
        if (item.estado_de_horario === 'RESERVADO') {
          map[fecha].horas[indiceExistente] = datosDelTurno;
        }
      }
    });

    setDiasDisponibles(Object.values(map));
    setIndexInicio(0);
  }, [medicalHistory]);

  const periodDays = window.innerWidth > 1024 ? 7 : 3;

  const visibleDays = diasDisponibles.slice(
    indexInicio,
    indexInicio + periodDays,
  );

  const availableDays = isMobile
    ? diasDisponibles.filter(d =>
        d.horas?.some(h => {
          const isHoraPasada = isPastHour(d.fecha, h.hora);
          return h.libre && !isHoraPasada;
        }),
      )
    : visibleDays;

  React.useEffect(() => {
    setMobileIndex(0);
  }, [availableDays.length]);

  const siguienteMobile = () => {
    if (mobileIndex < availableDays.length - 1) {
      setMobileIndex(prev => prev + 1);
    }
  };

  const anteriorMobile = () => {
    if (mobileIndex > 0) {
      setMobileIndex(prev => prev - 1);
    }
  };
  if (!open) return null;

  const siguiente = () => {
    if (indexInicio < diasDisponibles.length - periodDays) {
      setIndexInicio(indexInicio + 1);
      console.log('siguiente: ', indexInicio);
      setDayNotAvailableMessage(null);
    } else {
      console.log('ga siguiente');
      //setDayNotAvailableMessage('No existen más horarios disponibles');
      alert('No existen más horarios disponibles');
    }
  };

  const anterior = () => {
    if (indexInicio > 0) {
      setIndexInicio(indexInicio - 1);
      console.log('anterior: ', indexInicio);
      setDayNotAvailableMessage(null);
    } else {
      console.log('ga anterior');
      alert('No se pueden seleccionar fechas anteriores a la fecha actual');
      //setDayNotAvailableMessage('No se pueden seleccionar fechas anteriores a la fecha actual');
    }
  };

  const handleDoctorChange = async doctorCodigo => {
    setIsLoadingDoctor(true);
    try {
      await changeDoctorFilter(doctorCodigo);
    } finally {
      //setIsLoadingDoctor(false);
    }
  };

  return (
    <FlexContainer
      className="pos-fixed justify-center align-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        padding: 20,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column width-900px height-720px bgWhite borderrad20"
        style={{
          boxShadow: '0 6px 20px rgba(0,0,0,0.20)',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className="pos-abs pointer top16 right16 width-38px height-38px text-22 align-items-center justify-center fontWhite index-1"
          style={{
            background: '#023B7A',
            borderRadius: '50%',
            fontWeight: 'bold',
            boxShadow: '0px 3px 6px rgba(2,59,122,0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <FlexContainer
          className="flex-column bgWhite  borderrad16 pad20"
          style={{
            transform: 'scale(0.90)',
            transformOrigin: 'center',
          }}
        >
          <FlexContainer className="padlr60 width100 margb8 m-hide">
            <FlexContainer className="align-items-center pos-rel">
              <FlexContainer
                className="pos-abs left80 right80 top12 height-2px borderrad4 index-1"
                style={{
                  background: '#6f8ec0',
                }}
              />

              <FlexContainer className="justify-between width100 index-2">
                <Step
                  number={1}
                  label={'Especialidad'}
                  active={currentStep === 1}
                  onClick={goStep1}
                  disabled={false}
                />
                <Step
                  number={2}
                  label={'Médico'}
                  active={currentStep === 2}
                  onClick={goStep2}
                  disabled={false}
                />
                <Step
                  number={3}
                  label={'Fecha y Hora Disponibles'}
                  active={currentStep === 3}
                  onClick={() => setCurrentStep(3)}
                  disabled={false}
                />
                <Step
                  number={4}
                  label={'Confirmar Reserva de Cita'}
                  active={currentStep === 4}
                  onClick={goStep4}
                  disabled={currentStep < 4}
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer
            className={'align-items-center gap-10 padtb0 margb8 margt30'}
          >
            <FlexContainer
              className={
                'align-items-center width-24px height-24px justify-center pointer'
              }
              style={{ borderRadius: '50%', border: '2px solid #6f8ec0' }}
              onClick={goStep2}
            >
              <span
                className={'text-20 lineHeight-1'}
                style={{ color: '#6f8ec0', fontWeight: 'bold' }}
              >
                ‹
              </span>
            </FlexContainer>

            <div className={'text-18'} style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Agenda una cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}>
                {' '}
                Elige el día y la hora
              </span>
            </div>
          </FlexContainer>

          <FlexContainer className="m-flex-column flex-row gap-16 margt4 width100">
            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
              >
                <option>Miraflores</option>
              </select>

              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <FlexContainer className="pos-rel flex-1">
              <select
                className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
                style={{
                  border: '1px solid #C9C9C9',
                  color: '#144796',
                  fontWeight: 600,
                  appearance: 'none',
                }}
                onChange={e => {
                  //setIsLoadingDoctor(true);
                  handleCboEspeciality(e.target.value);
                  //setIsLoadingDoctor(false);
                }}
                value={selectedSpeciality}
              >
                <option value="TODAS">Todas las especialidades</option>
                {listaEspecialidades.map((s, i) => (
                  <option> {s}</option>
                ))}
              </select>

              <span
                className="pos-abs right10 text-24 pointerEventsNone"
                style={{
                  top: '50%',
                  transform: 'translateY(-50%) rotate(270deg)',
                  fontWeight: 900,
                  color: '#144796',
                }}
              >
                ‹
              </span>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer className="pos-rel width100 margt12">
            <select
              className="width100 height-40px padtb6 padr40px padl12 text-14 borderrad4 bgWhite"
              style={{
                border: '1px solid #C9C9C9',
                color: '#144796',
                fontWeight: 600,
                appearance: 'none',
              }}
              value={selectedDoctor?.codigo}
              onChange={e => handleDoctorChange(e.target.value)}
            >
              {filteredDoctorList.map((doc, i) => (
                <option key={i} value={doc?.codigo}>
                  {doc.nombres}
                </option>
              ))}
            </select>

            <span
              className="pos-abs right10 text-24 pointerEventsNone"
              style={{
                top: '50%',
                transform: 'translateY(-50%) rotate(270deg)',
                fontWeight: 900,
                color: '#144796',
              }}
            >
              ‹
            </span>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer
          className="flex-column bgWhite borderrad16 pad20"
          style={{
            transform: !isMobile ? 'scale(0.90)' : 'none',
            transformOrigin: 'center',
            position: 'relative',
            minHeight: isMobile ? 350 : 'auto',
          }}
        >
          {dayNotAvailableMessage && (
            <FlexContainer className="width100 justify-center text-18 margb40">
              <strong>{dayNotAvailableMessage}</strong>
            </FlexContainer>
          )}

          {(isLoadingDoctor || isLoadingSpeciality) && (
            <div
              className="borderrad10 height-328px"
              style={{
                position: 'absolute',
                inset: 0,
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.6)',
              }}
            >
              <div className="spinner" />
            </div>
          )}

          {!isLoadingDoctor &&
            !isLoadingSpeciality &&
            visibleDays.length === 0 &&
            (isMobile ? (
              <FlexContainer
                className="width100"
                style={{
                  minHeight: 280,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FlexContainer
                  className="flex-column align-center justify-center"
                  style={{
                    background: '#ffffff',
                    borderRadius: 14,
                    padding: '24px 20px',
                    textAlign: 'center',
                    maxWidth: 320,
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      lineHeight: 1.4,
                    }}
                  >
                    No hay fechas disponibles
                  </div>

                  <div
                    style={{
                      fontSize: 14,
                      marginTop: 4,
                    }}
                  >
                    para ese doctor
                  </div>
                </FlexContainer>
              </FlexContainer>
            ) : (
              <div
                className="borderrad10 height-328px"
                style={{
                  position: 'absolute',
                  inset: 0,
                  zIndex: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(255,255,255,0.6)',
                }}
              >
                <strong>No hay fechas disponibles para ese doctor</strong>
              </div>
            ))}

          {!isLoadingDoctor &&
            !isLoadingSpeciality &&
            (isMobile ? availableDays.length : visibleDays.length) >= 1 && (
              <>
                <FlexContainer
                  className="flex-row width100"
                  style={{
                    marginBottom: 20,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FlexContainer
                    onClick={isMobile ? anteriorMobile : anterior}
                    className="pointer width-40px height-40px align-center justify-center"
                    style={{
                      borderRadius: '50%',
                      color: '#6f8ec0',
                      fontSize: 40,
                      fontWeight: 700,
                      opacity: isMobile && mobileIndex === 0 ? 0.3 : 1,
                      cursor:
                        isMobile && mobileIndex === 0
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                  >
                    ‹
                  </FlexContainer>

                  <FlexContainer
                    className="flex-row gap-16"
                    style={{ alignItems: 'center' }}
                  >
                    {(isMobile
                      ? [availableDays[mobileIndex]]
                      : visibleDays
                    ).map((d, i) => (
                      <FlexContainer
                        key={i}
                        className="flex-column align-center pointer align-items-center"
                        style={{
                          background: '#023B7A',
                          color: '#fff',
                          borderRadius: 12,
                          padding: isMobile ? '12px 20px' : '10px 10px',
                          minWidth: isMobile ? 120 : 70,
                        }}
                        onClick={() =>
                          setSeleccion(s => ({
                            ...s,
                            day: d.fecha,
                          }))
                        }
                      >
                        <Label
                          className="text-18 m-text-12 fontBold"
                          style={{ lineHeight: '1', margin: '2px 0' }}
                        >
                          <strong>
                            {d.num} {d.mes}
                          </strong>
                        </Label>

                        <div
                          style={{
                            width: '90%',
                            height: '1px',
                            background: 'rgba(255, 255, 255, 0.5)',
                            margin: '2px 0',
                          }}
                        />

                        <Label className="text-14 m-text-12 fontSemiBold">
                          {d.dia}
                        </Label>
                      </FlexContainer>
                    ))}
                  </FlexContainer>

                  <FlexContainer
                    onClick={isMobile ? siguienteMobile : siguiente}
                    className="pointer width-40px height-40px align-center justify-center"
                    style={{
                      borderRadius: '50%',
                      color: '#6f8ec0',
                      fontSize: 40,
                      fontWeight: 700,
                      opacity:
                        isMobile && mobileIndex === availableDays.length - 1
                          ? 0.3
                          : 1,
                      cursor:
                        isMobile && mobileIndex === availableDays.length - 1
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                  >
                    ›
                  </FlexContainer>
                </FlexContainer>

                <FlexContainer
                  className={`width100 my-custom-scroll overflowY padr0 pos-rel padb16 ${
                    isMobile ? 'flex-column gap-10' : 'justify-center gap-8'
                  }`}
                  style={{
                    height: isMobile ? 280 : 300,
                  }}
                >
                  <FlexContainer
                    className={isMobile ? '' : 'grid padl10'}
                    style={
                      isMobile
                        ? { alignSelf: 'center' }
                        : {
                            gridTemplateColumns: `repeat(${visibleDays.length}, 1fr)`,
                            gap: 18,
                          }
                    }
                  >
                    {(isMobile
                      ? [availableDays[mobileIndex]]
                      : visibleDays
                    ).map((d, i) => (
                      <FlexContainer key={i} className="flex-column gap-8">
                        {d.horas.map((h, j) => {
                          const selected =
                            seleccion.day === d.fecha &&
                            seleccion.hour === h.hora;

                          const isHoraPasada = isPastHour(d.fecha, h.hora);

                          const isDisabled = !h.libre || isHoraPasada;

                          if (isDisabled) return null;

                          return (
                            <FlexContainer
                              key={j}
                              onClick={() => {
                                if (isDisabled) return;

                                const now = new Date();
                                const selectedDate = new Date(
                                  `${d.fecha}T${h.hora}:00`,
                                );

                                const diff = selectedDate - now;

                                const twoHoursInMs = 24 * 60 * 60 * 1000;

                                if (diff < twoHoursInMs) {
                                  alert(
                                    'ESTE TURNO SOLO PUEDE SER AGENDADO POR LLAMADA. COMUNÍQUESE AL 920 370 752',
                                  );
                                  return;
                                }

                                const payload = {
                                  fecha: d.fecha,
                                  hora: h.hora,
                                  estado: h.estado,
                                  doctor: selectedDoctor,
                                  historyDetails: h,
                                };

                                setSeleccion({
                                  day: d.fecha,
                                  hour: h.hora,
                                });

                                selectSchedule(payload);
                                goStep4();
                              }}
                              className="align-center justify-center"
                              style={{
                                background: selected ? '#023B7A' : '#FFFFFF',
                                color: selected ? '#FFFFFF' : '#023B7A',
                                border: '2px solid #023B7A',
                                borderRadius: 10,
                                padding: isMobile ? '12px 20px' : '8px 0',
                                cursor: 'pointer',
                                width: isMobile ? 120 : 88,
                                margin: isMobile ? '0 auto' : 0,
                                boxSizing: 'border-box',
                              }}
                            >
                              {h.hora}
                            </FlexContainer>
                          );
                        })}
                      </FlexContainer>
                    ))}
                  </FlexContainer>
                </FlexContainer>
              </>
            )}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaCitaFechaModal;
